import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-campo-default',
  templateUrl: './campo-default.component.html',
  styleUrls: ['./campo-default.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CampoDefaultComponent),
      multi: true
    }]
})
export class CampoDefaultComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input("descripcion_etiqueta") descripcion_etiqueta: string = "Campo genérico";
  @Input("placeholder_input") placeholder_input: string = "Ingrese su texto aquí";
  @Input("mensaje_error") mensaje_error: string = "";
  @Input("mensaje_ayuda") mensaje_ayuda: string = "";
  @Input() disabled: boolean = false;
  @Output("modelValueChange") modelValueChange: EventEmitter<string> = new EventEmitter<string>();
  modelValue: string = '';
  private onChange = (value: string) => { };
  private onTouched = () => { };

  writeValue(value: string): void {
    this.modelValue = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onInputChange(value: string): void {
    this.modelValue = value;
    // Notifica al ControlValueAccessor sobre el cambio de valor
    this.onChange(value);
  }
}
